import { Avatar, Col, Text, useTheme } from "@rally/ui-kit";
import { say } from "../../localization/say.ts";
import { calledBy } from "../../me/called.ts";
import { useFace } from "../../me/face.ts";
import type { Somebody } from "../panel/title.ts";

export const A_FACE_IS = 10;

export const FACES_BEFORE_A_COUNT = 5;

function OneFace({ who, size, mine }: { who: Somebody; size: number; mine: boolean }) {
  const theme = useTheme();
  const face = useFace((who as { avatar?: string | null }).avatar ?? null);
  return (
    <Col
      testID={mine ? "face-mine" : "face"}
      accessibilityLabel={calledBy(who) ?? who.handle}
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        overflow: "hidden",

        borderWidth: 1,
        borderColor: mine ? theme.color.accent : "transparent",
      }}
    >
      <Avatar
        name={calledBy(who) ?? who.handle}
        src={face}
        size={size - 2}
        tone={mine ? "accent" : "neutral"}
      />
    </Col>
  );
}

export function Faces({
  people,
  me,
  size = A_FACE_IS,
  cap = FACES_BEFORE_A_COUNT,
  testID,
}: {
  people: readonly (Somebody & { avatar?: string | null })[];
  me: string;
  size?: number;
  cap?: number;
  testID?: string;
}) {
  const mine = people.filter((one) => one.account === me);
  const ordered = [...mine, ...people.filter((one) => one.account !== me)];
  const drawn = ordered.slice(0, cap);
  const rest = ordered.length - drawn.length;

  return (
    <Col
      testID={testID}
      accessibilityLabel={say("title.who")(people.length)}
      style={{
        flexDirection: "row",

        flexWrap: "nowrap",
        alignItems: "center",
        height: size,
        gap: 2,
        overflow: "hidden",
      }}
    >
      {drawn.map((one) => (
        <OneFace key={one.account} who={one} size={size} mine={one.account === me} />
      ))}
      {rest > 0 ? (
        <Text
          testID="faces-count"
          color="text.tertiary"
          style={{ fontSize: size * 0.9, lineHeight: size, marginLeft: 2 }}
        >
          {say("title.andMore")(rest)}
        </Text>
      ) : null}
    </Col>
  );
}
